import styled from 'styled-components';
import { color, layout, space, typography } from 'styled-system';
const Paragraph = styled('p') `
  ${color}
  ${layout}
  ${space}
  ${typography}
`;
Paragraph.defaultProps = {
    fontWeight: 300,
    lineHeight: 1.25,
};
export { Paragraph };
//# sourceMappingURL=index.js.map